module.exports = __webpack_public_path__ + "img/28-5-2022_estrellas_thumb.d78e2e00.jpg";